import React from 'react';
import logo from 'parmasottositi-theme/components/LogoFooter/logo-footer.png';

const LogoFooter = () => (
  <figure className="footer-logo">
    <img src={logo} alt="" loading="lazy" width="87" height="86" />
  </figure>
);

export default LogoFooter;
